import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PlusIcon, XIcon } from '@phosphor-icons/react'

import { Button, ScrollableTabs, Text, TextAreaRichEditor } from '@reveni-io/reveni-ui'

import { getCurrentAvailableLanguage } from '@/configuration/helpers/helpers'

import { getLanguagesWithStatus, isStepEmpty } from './helpers'
import * as Styles from './styles'

const AddReturnSteps = ({ steps = {}, onAdd, onRemove, onChange, languages, disabled }) => {
  const { t, i18n } = useTranslation()
  const [language, setLanguage] = useState(getCurrentAvailableLanguage(languages, i18n.language))
  const stepsByLanguage = steps?.[language] || []

  const handleChangeStep = (value, id) => {
    onChange(value, language, id)
  }

  const handleChangeTab = value => setLanguage(value)

  const hasLanguagesAvailable = () => Object.values(steps).length > 0

  return (
    <Styles.MainContainer id="returnInstructionsEmpty">
      <Text type="titleS">{t('Instrucciones devolución')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Escribe los pasos que debe seguir el cliente para devolver los productos a la tienda y que se le enviarán por email. Las URLs e emails que incluyas se mostrarán como enlaces.'
        )}
      </Text>
      <Styles.Container>
        {hasLanguagesAvailable() && (
          <ScrollableTabs
            value={language}
            onChange={handleChangeTab}
            tabs={getLanguagesWithStatus(languages, steps, t)}
          />
        )}
        <Styles.StepsContainer>
          {stepsByLanguage.map((step, index) => (
            <Styles.StepContainer key={`${language}-${step.id}`}>
              <Styles.StepNumber>{index + 1}</Styles.StepNumber>
              <div>
                <TextAreaRichEditor
                  fullWidth
                  value={step.text}
                  textType="html"
                  onChange={data => handleChangeStep(data.html, step.id)}
                  helperText={isStepEmpty(step) && t('Este campo es requerido')}
                  error={isStepEmpty(step)}
                  richEditorTheme="bubble"
                  richEditorToolbarModules={['bold', 'italic', 'link']}
                  disabled={disabled}
                />
              </div>
              {!disabled && <XIcon size={24} weight="light" alt="remove step" onClick={() => onRemove(step.id)} />}
            </Styles.StepContainer>
          ))}
        </Styles.StepsContainer>
        {!disabled && (
          <div>
            <Button variant="text" onClick={onAdd}>
              <PlusIcon size={24} />
              {t('Añadir paso')}
            </Button>
          </div>
        )}
      </Styles.Container>
    </Styles.MainContainer>
  )
}
export default AddReturnSteps
